var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchActiveSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16777 12.7432C4.17789 12.7432 1.72697 10.2535 1.72697 7.24036C1.72697 4.21625 4.17789 1.73726 7.16777 1.73726C10.1468 1.73726 12.6083 4.21625 12.6083 7.24036C12.6083 10.2535 10.1468 12.7432 7.16777 12.7432ZM7.16777 13.4805C8.60439 13.4805 9.94624 12.9675 10.9921 12.1128L15.4924 16.6755C15.598 16.7823 15.7566 16.8571 15.9152 16.8571C16.2955 16.8571 16.5383 16.5685 16.5383 16.2267C16.5383 16.0665 16.4855 15.9168 16.3587 15.7993L11.8794 11.2473C12.7879 10.168 13.3372 8.75755 13.3372 7.24036C13.3372 3.81031 10.5588 1 7.16777 1C3.77654 1 0.998047 3.81031 0.998047 7.24036C0.998047 10.6702 3.77654 13.4805 7.16777 13.4805Z",
    fill: "#0e0333",
    stroke: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchActiveSmall);
export default __webpack_public_path__ + "static/media/ic-search-active-small.8b6d3b023acd87bc32fdb6e359ad07f8.svg";
export { ForwardRef as ReactComponent };